var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9248 12.8494C8.14312 10.0613 10.8651 7.058 11.595 2.75351C10.663 5.03446 9.23255 6.98957 7.53921 8.82519L5.77202 7.50658C6.56493 6.63765 7.18403 5.66661 8.41032 5.33968C8.88063 5.21477 9.35421 4.83461 9.66811 4.44467C10.4556 3.46169 11.1496 2.40484 11.8861 1.38167C12.1587 1.00151 12.4194 0.610492 12.7268 0.260746C13.0341 -0.089001 13.4263 -0.0803095 13.7282 0.235766C14.075 0.577376 14.368 0.969596 14.5971 1.39905C15.0413 2.30328 15.4383 3.22994 15.7865 4.1753C17.028 7.59782 18.2369 11.0301 19.4588 14.4592C19.4804 14.5075 19.4915 14.5599 19.4915 14.6128C19.4915 14.6658 19.4804 14.7182 19.4588 14.7665C18.8129 14.1757 18.167 13.5848 17.5211 12.9939C16.3263 11.9001 15.2836 11.8447 14.0638 12.9081C13.4556 13.4392 12.9483 14.0877 12.3977 14.6851C11.797 15.3368 11.2485 16.046 10.5827 16.6206C9.98201 17.1387 9.25319 17.508 8.50048 17.9957C8.09751 17.0746 7.76297 16.3056 7.42734 15.5377C7.24595 15.125 7.07976 14.7046 6.87447 14.3038C6.4878 13.5424 5.98708 12.8951 4.9248 12.8494Z",
    fill: "#007987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59022 12.4822L0.00585938 9.88735C1.10832 9.45288 2.1782 9.14224 3.14598 8.62631C4.31035 8.00285 5.25532 8.08322 6.14163 9.06078C6.29587 9.23022 6.51093 9.34426 6.80963 9.56802L3.59022 12.4822Z",
    fill: "#007987"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4935,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlab);
export default __webpack_public_path__ + "static/media/Matlab.82ff9c75b38649749db0c67f93abdf46.svg";
export { ForwardRef as ReactComponent };